import { ref, getDownloadURL } from 'firebase/storage';
import { storage } from './config';

/**
 * Get the download URL for the sundog logo from Firebase Storage
 */
export const getSundogLogoUrl = async () => {
  try {
    // Reference to the sundog logo in Firebase Storage
    const logoRef = ref(storage, 'images/sundog-logo.png');
    
    // Get the download URL
    const url = await getDownloadURL(logoRef);
    return url;
  } catch (error) {
    console.error('Error getting sundog logo URL:', error);
    // Return a fallback or null if the image doesn't exist
    return null;
  }
};

/**
 * Get the download URL for any image from Firebase Storage
 */
export const getImageUrl = async (imagePath) => {
  try {
    const imageRef = ref(storage, imagePath);
    const url = await getDownloadURL(imageRef);
    return url;
  } catch (error) {
    console.error(`Error getting image URL for ${imagePath}:`, error);
    return null;
  }
};
